import React from "react";

import "./TimePicker.scss";

export const TimeLabel = ({ time }) => {
  return <span className="custom-time-label">{time}</span>;
};
